import { createWebHistory, createRouter } from "vue-router";
import { useAuthStore } from "@/state/pinia";
import routes from "./routes";
import appConfig from "../app.config.json";

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0, left: 0 };
    }
  }
});

/**
 * GESTIONNAIRE DE NAVIGATION (Before Each)
 */
router.beforeEach((routeTo, routeFrom, next) => {
  const auth = useAuthStore();
  const loggeduser = localStorage.getItem("user");

  const redirectToLogin = () => {
    next({ name: "login", query: { redirectFrom: routeTo.fullPath } });
  };

  // 1. CAS FIREBASE
  if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired);
    if (!authRequired) return next();

    if (auth.loggedIn) {
      return auth.validate().then((validUser) => {
        validUser ? next() : redirectToLogin();
      });
    }
    return redirectToLogin();
  } 
  
  // 2. CAS AUTHENTIFICATION STANDARD (Laravel/API)
  else {
    const authRequired = routeTo.matched.some((route) => route.meta.authRequired);

    if (authRequired && !loggeduser) {
      return redirectToLogin();
    }

    if (loggeduser) {
      try {
        const user = JSON.parse(loggeduser);
        const userRoleName = user?.role?.name;
        const typePartenaire = user?.partenaire?.type?.toUpperCase(); // Récupération du type
        const requiredRoles = routeTo.meta.roles;

        if (routeTo.name === "login") {
          return next({ name: "homePage" });
        }

        // --- PROTECTION STRICTE WALLET POUR HOPITAL/PHARMACIE ---
        if (routeTo.name === "Wallet") {
          if (typePartenaire === 'HOPITAL') {
            return next({ name: 'hopital-dashboard' });
          }
          if (typePartenaire === 'PHARMACIE') {
            return next({ name: 'pharmacie-dashboard' });
          }
        }

        // Vérification des rôles (Permissions)
        if (requiredRoles && requiredRoles.length > 0) {
          if (!userRoleName || !requiredRoles.includes(userRoleName)) {
            console.warn(`Accès refusé. Rôle: ${userRoleName}, Requis: ${requiredRoles}`);
            return next({ name: "homePage" });
          }
        }
      } catch (error) {
        console.error("Erreur de session, déconnexion forcée.");
        localStorage.removeItem("user");
        return redirectToLogin();
      }
    }

    next();
  }
});

/**
 * RESOLUTION FINALE (Titres et Hooks beforeResolve)
 */
router.beforeResolve(async (routeTo, routeFrom, next) => {
  try {
    for (const route of routeTo.matched) {
      await new Promise((resolve, reject) => {
        if (route.meta && route.meta.beforeResolve) {
          route.meta.beforeResolve(routeTo, routeFrom, (...args) => {
            if (args.length) {
              next(...args);
              reject(new Error("Redirected"));
            } else {
              resolve();
            }
          });
        } else {
          resolve();
        }
      });
    }
  } catch (error) {
    return;
  }

  if (routeTo.meta.title) {
    document.title = routeTo.meta.title + " | " + appConfig.title;
  }
  
  next();
});

export default router;